import { FC } from "react";

import { Box, SxProps, Theme } from "@mui/material";

import { useThemedBrandingColor } from "./useThemedBrandingColor";

import { mergeSx } from "@/common/helpers/mergeSx";
import { Zeffy as ZeffyLogo } from "@/icons/other";

type ThemedZeffyLogoProps = {
  href?: string;
  onClick?: () => void;
  sx?: SxProps<Theme>;
  width?: number | string | { xs?: number; md?: number };
  height?: number | string;
};

export const ThemedZeffyLogo: FC<ThemedZeffyLogoProps> = ({ href, sx, width, height, onClick, ...rest }) => {
  const logoColor = useThemedBrandingColor();

  const finalWidth = width ?? { xs: 66, md: 100 };
  const finalHeight = height ?? "100%";

  return (
    <Box
      display="inline-flex"
      alignItems="center"
      justifyContent="center"
      width={finalWidth}
      height={finalHeight}
      aria-label="Zeffy"
      {...(href
        ? {
            component: "a" as const,
            href,
            target: "_blank",
            rel: "noopener noreferrer",
            onClick,
          }
        : { role: "img" })}
      sx={mergeSx(
        {
          color: logoColor,
          textDecoration: "none",
          ...(href && {
            cursor: "pointer",
            ["&:hover"]: {
              color: logoColor,
              opacity: 0.8,
            },
          }),
        },
        sx
      )}
      data-test="zeffy-logo-wrapper"
      {...rest}
    >
      <ZeffyLogo width="100%" height="100%" fill="currentColor" />
    </Box>
  );
};
